import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-17133 — two people someone marked "not the same person", so the
 * possible-duplicate notice stops pairing them. Stored once per pair, the
 * lower person id first.
 *
 * SM1 exposure: none (a new table).
 */
@Index('contact_duplicate_dismissal__pair', ['fkContactIdLow', 'fkContactIdHigh'], { unique: true })
@Entity('contact_duplicate_dismissal')
export class ContactDuplicateDismissalEntity extends BaseEntity {
	@Column('int', { name: 'fk_contact__id_low', unsigned: true })
	public fkContactIdLow!: number;

	@Column('int', { name: 'fk_contact__id_high', unsigned: true })
	public fkContactIdHigh!: number;
}
